import {
  ONBOARDING_SET_MODE,
  ONBOARDING_SET_STEP,
  ONBOARDING_SET_ANSWERS,
  ONBOARDING_TICK_CHECKLIST,
  ONBOARDING_RESET,
  ONBOARDING_HYDRATE,
} from "./actionType";

const LS_KEY = "crmit_onboarding_v1";

export const DEFAULT_STATE = {
  mode: null,           // null | "guided" | "skipped"
  currentStep: 1,
  answers: {
    businessType: "",   // "trades" | "professional" | "events" | "retail" | "other"
    teamSize:     "",   // "solo" | "small" | "larger"
    primaryGoal:  "",   // "customers" | "jobs" | "invoices" | "all"
  },
  checklist: {
    account:  true,
    customer: false,
    job:      false,
    invoice:  false,
    company:  false,
    calendar: false,
  },
};

function persist(state) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch (e) { console.warn("onboarding persist failed", e); }
  return state;
}

export function loadOnboardingState() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { ...DEFAULT_STATE };
    return { ...DEFAULT_STATE, ...JSON.parse(raw) };
  } catch (e) {
    return { ...DEFAULT_STATE };
  }
}

const initialState = loadOnboardingState();

const Onboarding = (state = initialState, action) => {
  let next;
  switch (action.type) {
    case ONBOARDING_HYDRATE:
      return persist({ ...DEFAULT_STATE, ...action.payload });

    case ONBOARDING_SET_MODE:
      next = { ...state, mode: action.payload };
      return persist(next);

    case ONBOARDING_SET_STEP:
      next = { ...state, currentStep: action.payload };
      return persist(next);

    case ONBOARDING_SET_ANSWERS:
      next = { ...state, answers: { ...state.answers, ...action.payload } };
      return persist(next);

    case ONBOARDING_TICK_CHECKLIST:
      next = { ...state, checklist: { ...state.checklist, [action.payload]: true } };
      return persist(next);

    case ONBOARDING_RESET:
      return persist({ ...DEFAULT_STATE });

    default:
      return state;
  }
};

export default Onboarding;
